<si-cookie-banner [cookieUrl]="cookieUrl"></si-cookie-banner>
<router-outlet></router-outlet>
